import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { CustomerAuthProvider } from './contexts/CustomerAuthContext'
import { AdminAuthProvider } from './contexts/AdminAuthContext'
import { SuperAdminAuthProvider } from './contexts/SuperAdminAuthContext'
import Layout from './components/Layout'
import CustomerLogin from './pages/customer/CustomerLogin'
import CustomerDashboard from './pages/customer/CustomerDashboard'
import CustomerLoans from './pages/customer/CustomerLoans'
import FinancialDataEntry from './pages/customer/FinancialDataEntry'
import AdminLogin from './pages/admin/AdminLogin'
import AdminDashboard from './pages/admin/AdminDashboard'
import CustomerSearch from './pages/admin/CustomerSearch'
import FinancialStatements from './pages/admin/FinancialStatements'
import AdminFinancialStatements from './pages/admin/AdminFinancialStatements'
import SuperAdminLogin from './pages/admin/SuperAdminLogin'
import SuperAdminDashboard from './pages/admin/SuperAdminDashboard'
import SettlementDashboard from './pages/admin/SettlementDashboard'
import ProtectedRoute from './components/ProtectedRoute'
import AdminProtectedRoute from './components/AdminProtectedRoute'
import SuperAdminProtectedRoute from './components/SuperAdminProtectedRoute'

// Admin Financial Data Entry
import AdminFinancialDataEntry from './pages/admin/AdminFinancialDataEntry'

// Katale Marketplace Pages
import KataleHome from './pages/katale/KataleHome'
import KataleProducts from './pages/katale/KataleProducts'
import KataleCart from './pages/katale/KataleCart'
import KataleMyProducts from './pages/katale/KataleMyProducts'
import KataleAddProduct from './pages/katale/KataleAddProduct'
import KataleOrders from './pages/katale/KataleOrders'
import KataleSettlements from './pages/katale/KataleSettlements'
import KataleRatings from './pages/katale/KataleRatings'

function App() {
  return (
    <AuthProvider>
      <CustomerAuthProvider>
        <AdminAuthProvider>
          <SuperAdminAuthProvider>
            <Router>
              <Layout>
                <Routes>
                  {/* Default route - redirect to customer login */}
                  <Route path="/" element={<Navigate to="/customer/login" replace />} />
                  <Route path="/customer/login" element={<CustomerLogin />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  
                  {/* Super Admin Login - separate from regular admin */}
                  <Route path="/adminsp" element={<SuperAdminLogin />} />
                  
                  {/* Protected customer routes */}
                  <Route path="/customer/dashboard" element={
                    <ProtectedRoute>
                      <CustomerDashboard />
                    </ProtectedRoute>
                  } />
                  <Route path="/customer/loans" element={
                    <ProtectedRoute>
                      <CustomerLoans />
                    </ProtectedRoute>
                  } />
                  <Route path="/customer/financial-data" element={
                    <ProtectedRoute>
                      <FinancialDataEntry />
                    </ProtectedRoute>
                  } />
                  
                  {/* Protected admin routes */}
                  <Route path="/admin/dashboard" element={
                    <AdminProtectedRoute>
                      <AdminDashboard />
                    </AdminProtectedRoute>
                  } />
                  <Route path="/admin/customers" element={
                    <AdminProtectedRoute>
                      <CustomerSearch />
                    </AdminProtectedRoute>
                  } />
                  <Route path="/admin/financial-statements" element={
                    <AdminProtectedRoute>
                      <AdminFinancialStatements />
                    </AdminProtectedRoute>
                  } />
                  <Route path="/admin/financial-statements/:customerId" element={
                    <AdminProtectedRoute>
                      <FinancialStatements />
                    </AdminProtectedRoute>
                  } />
                  <Route path="/admin/settlements" element={
                    <AdminProtectedRoute>
                      <SettlementDashboard />
                    </AdminProtectedRoute>
                  } />
                  <Route path="/admin/financial-data-entry" element={
                    <AdminProtectedRoute>
                      <AdminFinancialDataEntry />
                    </AdminProtectedRoute>
                  } />
                  
                  {/* Super Admin Dashboard - protected route */}
                  <Route path="/adminsp/dashboard" element={
                    <SuperAdminProtectedRoute>
                      <SuperAdminDashboard />
                    </SuperAdminProtectedRoute>
                  } />
                  
                  {/* Katale Marketplace Routes - protected customer routes */}
                  <Route path="/katale" element={
                    <ProtectedRoute>
                      <KataleHome />
                    </ProtectedRoute>
                  } />
                  <Route path="/katale/products" element={
                    <ProtectedRoute>
                      <KataleProducts />
                    </ProtectedRoute>
                  } />
                  <Route path="/katale/cart" element={
                    <ProtectedRoute>
                      <KataleCart />
                    </ProtectedRoute>
                  } />
                  <Route path="/katale/my-products" element={
                    <ProtectedRoute>
                      <KataleMyProducts />
                    </ProtectedRoute>
                  } />
                  <Route path="/katale/add-product" element={
                    <ProtectedRoute>
                      <KataleAddProduct />
                    </ProtectedRoute>
                  } />
                  <Route path="/katale/orders" element={
                    <ProtectedRoute>
                      <KataleOrders />
                    </ProtectedRoute>
                  } />
                  <Route path="/katale/settlements" element={
                    <ProtectedRoute>
                      <KataleSettlements />
                    </ProtectedRoute>
                  } />
                  <Route path="/katale/ratings" element={
                    <ProtectedRoute>
                      <KataleRatings />
                    </ProtectedRoute>
                  } />
                  
                  {/* Catch all */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </Router>
          </SuperAdminAuthProvider>
        </AdminAuthProvider>
      </CustomerAuthProvider>
    </AuthProvider>
  )
}

export default App
